import { requestWithToken as request } from "./api";

// Personalización del onboarding: nombre de fantasía (opcional) + logo
// (opcional). Multipart porque el logo viaja como archivo; el backend resuelve
// la empresa desde el usuario autenticado (no requiere id).
export const personalizeCompany = ({ fantasyName, logoFile } = {}) => {
    const formData = new FormData();
    if (fantasyName != null) {
        formData.append("fantasy_name", fantasyName);
    }
    if (logoFile) {
        formData.append("file", logoFile);
    }
    return request.post("/company/personalize/", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};
